import { useNavigate, type NavigateOptions } from '@tanstack/react-router';
import { fireAndForget } from '@web/ui/core/utils';

/**
 * Returns a callback that navigates to the declared parent route. The
 * fallback is the always-correct destination — browser history is
 * intentionally ignored because tab switches inside a layout push entries
 * and `history.back()` would cycle through them instead of returning to
 * the parent.
 */
export function useGoBack(fallback: NavigateOptions): () => void {
  const navigate = useNavigate();
  return () => {
    fireAndForget(navigate(fallback));
  };
}
